import {WidgetType} from '@codemirror/view'
import {clsx} from 'clsx'

import styles from '../decorate-markdown.module.css'

export class ThematicBreakWidget extends WidgetType {
  #active: boolean
  constructor(active: boolean) {
    super()
    this.#active = active
  }

  toDOM() {
    const element = document.createElement('hr')
    element.className = clsx(styles.block, this.#active && styles.activeBlock)
    return element
  }

  override eq(widget: ThematicBreakWidget) {
    return widget.#active === this.#active
  }

  override ignoreEvent() {
    return false
  }
}
